/*
  Need to declare lotPk and method getLot()
*/

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import LotStatusNotifications from '../lot/LotStatusNotifications'
import LotPlan from '../lot/Tabs/LotPlan'
import LotDocumentsList from '../lot/Tabs/LotDocumentsList'
import ProgramDocumentsList from '../program/Tabs/ProgramDocumentsList'
import GmapFilter from '@/components/utils/GmapFilter'
import { mapGetters, mapState } from 'vuex'
import { find, filter, isNil, concat, uniq, compact, flattenDeep } from 'lodash'
import { exportXls } from '@/utils'
import { DefaultValues, EventTrackerMx, GenericList } from '@/mixins'

const PANELS = Object.freeze({
  LOTDOCS: 'LOTDOCS',
  PROGDOCS: 'PROGDOCS',
  PLAN: 'PLAN'
})
const PANELSLIST = Object.freeze({
  LOGEMENT: 'LOGEMENT',
  PARKING: 'PARKING'
})

export default {
  data () {
    return {
      lot: null,
      panel: PANELS.PLAN,
      PANELS: PANELS,
      panelList: PANELSLIST.LOGEMENT,
      PANELSLIST: PANELSLIST,
      adv: null,
      program: null,
      lots: [],
      rawOptions: [],
      external: null,
      loading: false,
      loadingMap: false,
      optionLoading: false,
      advLoading: false,
      loadingLots: false,
      swiperOption: {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        loop: true,
        autoHeight: true
      },
      contacts: [],
      service: this.$api.lotService,
      promoteurAccess: null,
      programAccess: null,
      showLastEvents: false,
      lotTotalPage: 0,
      lotCurrentPage: 0,
      sortBy: {},
      loadingOptionAction: false,
      accesses: [],
      accessExternalSellersCount: 0,
      accessSellersCount: 0,
      loadingAccess: false,
      promoteurAccesses: [],
      allotment: 0
    }
  },
  components: {
    swiperSlide,
    swiper,
    LotPlan,
    LotDocumentsList,
    ProgramDocumentsList,
    GmapFilter,
    LotStatusNotifications
  },
  mixins: [DefaultValues, EventTrackerMx, GenericList],
  watch: {
    '$route' () {
      this.init()
      this.scrollToHash()
      // this.$scrollTo('#app', 700)
    },
    quickview ({mode, params, results}) {
      if (results) {
        if (mode === 'OPTION_UPDATE_DATE') {
          this.loadingOptionAction = true
          this.changeOptionEndDate(results)
        }
      }
    }
  },
  computed: {
    ...mapState(['currentUser', 'runningOptions', 'wishlists', 'quickview', 'configs']),
    ...mapGetters(['isAdmin', 'isSectorManager', 'isManager', 'currentUserPk', 'isSeller', 'isExternal', 'isEditor', 'currentCompanyPk', 'isDistributeurMode', 'displayRemuneration']),
    l () {
      return this.lot
    },
    isParking () {
      return this.lot.nature === 'parking'
    },
    access () {
      if (isNil(this.programAccess) === false) {
        return this.programAccess
      }
      if (isNil(this.promoteurAccess) === false) {
        return this.promoteurAccess
      }
      return null
    },
    pendingOptions () {
      if (!this.optionLoading) {
        return this.rawOptions.filter(x => {
          return x.status === 'pending' && (this.userPendingOption ? this.userPendingOption.pk !== x.pk : true)
        })
      }
    },
    mapOptions () {
      return {
        streetViewControl: false,
        styles: this.mapStyle
      }
    },
    canSeeOption () {
      // L'admin peut tout voir
      if (this.isAdmin || this.isSectorManager) {
        return true
      }
      // Le vendeur peut voir ses propres options
      if (this.currentUserPk === this.firstOption.seller) {
        return true
      }
      // Un manager externe pourra voir toutes les options posées par des vendeurs de sa société
      if (this.isExternal && this.isManager && this.firstOption.company === this.currentCompanyPk) {
        return true
      }
      // Un manager externe pourra voir toutes les options posées par des vendeurs internes.
      if (!this.isExternal && this.isManager && isNil(this.firstOption.company)) {
        return true
      }
      return false
    },
    address () {
      if (this.program) {
        return this.program.address
      }
    },
    externalSale () {
      if (isNil(this.lot.external_sale) || isNil(this.lot.external_sale.created_on)) {
        return null
      }
      return this.lot.external_sale
    },
    canBeSold () {
      return ['available', 'optioned'].includes(this.lot.status) && isNil(this.externalSale)
    },
    canBeOptioned () {
      const okStatus = ['available', 'optioned']
      if (!okStatus.includes(this.lot.status)) {
        return false
      }
      // if (this.lot.locked) {
      //   return false
      // }
      const programOkStatus = ['available', 'private']
      if (!this.program || !programOkStatus.includes(this.program.status)) {
        return false
      }
      if (this.isAdmin) {
        return true
      }
      if (this.lot && this.program) {
        const verifyOptions = this.runningOptions.filter(x => x.lot === this.lot.pk)
        return programOkStatus.includes(this.program.status) && this.program.is_optionable && okStatus.includes(this.lot.status) && !verifyOptions.length
      }
    },
    canBeDenunce () {
      const okStatus = ['available', 'optioned']
      if (!okStatus.includes(this.lot.status)) {
        return false
      }
      const programOkStatus = ['available', 'private']
      if (!this.program || !programOkStatus.includes(this.program.status)) {
        return false
      }
      if (this.isAdmin || this.isSectorManager || this.isManager || this.isSeller || this.isExternal) {
        return true
      }
      if (this.lot && this.program) {
        return programOkStatus.includes(this.program.status) && this.program.is_optionable && okStatus.includes(this.lot.status)
      }
    },
    canChangeStatus () {
      const okStatus = ['available', 'draft', 'archived']
      return okStatus.includes(this.lot.status) && this.isAdmin
    },
    firstOption () {
      if (!this.optionLoading) {
        if (!this.isOptioned) {
          return false
        }
        return find(this.rawOptions, x => {
          return x.status === 'approved'
        })
      }
    },
    userPendingOption () {
      if (this.isAdmin || this.isSectorManager) return
      if (!this.optionLoading) {
        return find(this.runningOptions, x => {
          return x.status === 'pending' && x.lot === this.lot.pk && [x.update_author, x.seller].includes(this.currentUserPk)
        })
      }
    },
    isOptioned () {
      return this.lot && this.lot.status === 'optioned'
    },
    isReserved () {
      return this.lot && this.lot.status === 'reserved'
    },
    isSold () {
      return this.lot && this.lot.status === 'sold'
    },
    statusBarColor () {
      const COLORS = {
        'available': 'has-status-bar--disponible',
        'draft': 'has-status-bar--draft',
        'sold': 'has-status-bar--acte',
        'reserved': 'has-status-bar--reserve',
        'optioned': 'has-status-bar--optionne'
      }
      return COLORS[this.lot.status]
    },
    statusColor () {
      const COLORS = {
        'available': 'is-disponible',
        'draft': 'is-draft',
        'archived': 'is-warning',
        'private': 'is-private'
      }
      return COLORS[this.program.status]
    },
    programPk () {
      if (this.program) {
        return this.program.pk
      }
    },
    options () {
      if (!this.optionLoading) {
        return this.rawOptions
      }
    },
    waitingList () {
      if (!this.optionLoading) {
        return filter(this.rawOptions, x => {
          return x.status === 'waiting_list'
        })
      }
    },
    canBeDeleted () {
      const okStatus = ['available', 'draft', 'archived']
      return !isNil(this.lot) && this.isAdmin && okStatus.includes(this.lot.status)
    },
    wishlisted () {
      return this.wishlists.find(w => w.lot === this.lot.pk)
    },
    panelComponent () {
      const components = {
        [PANELS.LOTDOCS]: 'LotDocumentsList',
        [PANELS.PROGDOCS]: 'ProgramDocumentsList',
        [PANELS.PLAN]: 'LotPlan'
      }
      return components[this.panel]
    },
    statusLotList () {
      return this.statusList.filter(x => ['available', 'draft'].includes(x.value))
    },
    paramsList () {
      return {
        loading: this.loadingLots,
        totalPage: this.lotTotalPage,
        sortBy: this.sortBy,
        currentPage: this.lotCurrentPage,
        nextPage: this.nextPage
      }
    },
    brochure () {
      if (this.program.documents && this.program.documents.length) {
        return this.program.documents.find(x => x.filename === 'Brochure du programme')
      }
    },
    reservation () {
      if (this.program.documents && this.program.documents.length) {
        return this.program.documents.find(x => x.filename === 'Dossier de réservation')
      }
    },
    displayed_program_documents_flux () {
      if (this.program.documents_flux && this.program.documents_flux.length > 0) {
        return this.program.documents_flux.filter(document => document.display)
      } else return []
    },
    displayed_lot_documents_flux () {
      if (this.lot.documents_flux && this.lot.documents_flux.length > 0) {
        return this.lot.documents_flux.filter(document => document.display)
      } else return []
    },
    filteredLogement () {
      if (this.lots && this.lots) {
        return this.lots.filter(x => x.nature !== 'parking')
      }
    },
    filteredParking () {
      if (this.lots && this.lots) {
        return this.lots.filter(x => x.nature === 'parking')
      }
    },
    lotsList () {
      if (this.panelList === PANELSLIST.PARKING) {
        return this.filteredParking
      } else return this.filteredLogement
    },
    annexes () {
      if (this.isParking) return
      let annexes = {}
      for (let annex of this.lot.annexes) {
        if (!annex.is_parking) {
          let annexType = annex.annex_type
          if ((annexType in annexes) === false) {
            annexes[annexType] = {count: 0, surface: [], infos: []}
          }
          annexes[annexType].count++
          if (annex.surface) annexes[annexType].surface.push(annex.surface)
          if (annex.info) annexes[annexType].infos.push(annex.info)
        }
      }
      return annexes
    },
    parkings () {
      if (this.isParking) return
      let parkings = {}
      for (let annex of this.lot.annexes) {
        if (annex.is_parking) {
          let annexType = annex.annex_type
          if ((annexType in parkings) === false) {
            parkings[annexType] = {count: 0, infos: ''}
          }
          parkings[annexType].count++
          if (annex.info) {
            if (parkings[annexType].infos.length) {
              parkings[annexType].infos += `, ${annex.info}`
            } else {
              parkings[annexType].infos += `${annex.info}`
            }
          }
        }
      }
      let pkgs = {}
      pkgs.type = Object.keys(parkings)
      pkgs.infos = flattenDeep(Object.values(parkings).map(x => x.infos))
      pkgs.count = Object.values(parkings).map(x => x.count)
      pkgs.totalCount = Object.values(parkings).map(x => x.count).reduce((a, b) => {
        return a + b
      }, 0)
      return pkgs
    },
    taxDispositifs () {
      if (this.isParking) return
      return compact(this.lot.tax_dispositifs.map(x => {
        if (x in this.taxDispositifsData) {
          return this.taxDispositifsData[x].label
        }
      })).join(', ')
    }
  },
  methods: {
    init () {
      this.rawOptions = []
      this.contacts = []
      this.lot = null
      this.program = null
      this.adv = null
      this.external = null
      this.promoteurAccess = null
      this.programAccess = null
      this.showLastEvents = false
      this.getLot()
    },
    changePanel (panel) {
      this.panel = panel
    },
    changeListPanel (panel) {
      this.panelList = panel
    },
    updateStatus () {
      this.patchLot({status: this.lot.status})
    },
    xlsExportUrl () {
      const query = {pk: [this.lot.pk]}
      return exportXls('lots-export', query, true, `LOT-${this.lot.ref}`)
    },
    getLots (programPk, query, page = 1) {
      this.loadingLots = true
      let params = {
        page,
        program: programPk,
        ...query
      }
      this.$api.lotService.get(params).then(r => {
        this.loadingLots = false
        // this.lots = r.data.items
        this.lotTotalPage = r.data.pages
        this.lotCurrentPage = r.data.page
        if (page > 1) {
          let totalLots = concat(r.data.items, this.lots)
          this.lots = totalLots
        } else {
          this.lots = r.data.items
        }
        if (r.data.page < r.data.pages) {
          page++
          this.getLots(programPk, {}, page)
        }
      }).catch(() => {
        this.loadingLots = false
      })
    },
    getProgram (programPk) {
      this.loading = true
      this.$api.programService.getOne(programPk).then(res => {
        this.loading = false
        this.program = res.data
        // if (!this.lot.plan && (!this.lot.documents || !this.lot.documents.length) && ((this.program.documents && this.program.documents.length) || (this.program.documents_flux && this.program.documents_flux.length))) {
        //   this.panel = PANELS.PROGDOCS
        // }
      }).catch(err => {
        console.log(err)
        this.loading = false
        this.$router.replace({name: 'NotFound'})
      })
    },
    getOptions () {
      this.optionLoading = true
      this.service.getOptions(this.lotPk).then(res => {
        this.optionLoading = false
        this.rawOptions = res.data
      }).catch(err => {
        this.optionLoading = false
        console.log(err)
      })
    },
    patchLot (data) {
      this.service.patch(this.lotPk, data)
        .then(res => {
          this.lot = res.data
          this.$notify({
            type: 'is-success',
            text: 'Lot modifié avec succès'
          })
        })
    },
    getExternal () {
      this.service.getExternal(this.lotPk).then(r => {
        this.external = r.data
      }).catch(() => {
        this.external = null
      })
    },
    getAdv () {
      this.advLoading = true
      this.$api.advService.get({lot: this.lotPk}).then(r => {
        this.advLoading = false
        if (r.data.items && r.data.items.length) {
          this.adv = r.data.items[0]
        }
      }).catch(() => {
        this.advLoading = false
      })
    },
    openOptionModal () {
      this.$router.push({name: 'OptionCreate', query: {lot: this.lot.pk}})
    },
    openDenunciationVue () {
      this.$router.push({name: 'DenunciationCreate', query: {lot: this.lotPk}})
    },
    getContacts (query) {
      if (this.currentUserPk) {
        this.$api.contactService.get({ref: query, seller: this.currentUserPk}).then(r => {
          this.contacts = r.data.items
        })
      }
    },
    deleteLot () {
      this.deleteItem(this.lotPk)
    },
    successDelete () {
      this.$router.goBack()
      this.$notify({
        type: 'is-success',
        text: 'Élément supprimé.'
      })
    },
    errorDelete (err) {
      console.log('cant remove lot > ', err)
      this.$notify({
        type: 'is-danger',
        text: 'Impossible de supprimer ce lot.'
      })
    },
    getProgramAccess () {
      let query = {
        program: this.lot.program,
        company: this.currentCompanyPk,
        per_page: 1
      }
      this.$api.accessService.get(query).then(r => {
        if (r.data.items.length > 0) {
          this.programAccess = r.data.items[0]
        }
      })
    },
    getPromoteurAccess () {
      let query = {
        promoteur: this.lot.promoteur,
        company: this.currentCompanyPk,
        per_page: 1
      }
      this.$api.accessService.getPromoteurAccess(query).then(r => {
        if (r.data.items.length > 0) {
          this.promoteurAccess = r.data.items[0]
        }
      })
    },
    getUserInAccesses () {
      this.loadingAccess = true
      const funcs = []
      if (this.lot && this.lot.program) {
        let query2 = { program: this.lot && this.lot.program ? this.lot.program.pk || this.lot.program : null }
        funcs.push(this.$api.accessService.get(query2))
      }
      if (this.lot && this.lot.promoteur) {
        let query1 = { promoteur: this.lot && this.lot.promoteur ? this.lot.promoteur.pk || this.lot.promoteur : null }
        funcs.push(this.$api.accessService.getPromoteurAccess(query1))
      }
      Promise.all(funcs).then(([programAccess, promoteurAccess]) => {
        let allProgramAccesses = []
        if (promoteurAccess) allProgramAccesses = concat(promoteurAccess.data.items)
        if (programAccess) allProgramAccesses = concat(programAccess.data.items)

        this.accessExternalSellersCount = uniq(compact(allProgramAccesses.map(x => {
          if (x && x.company) return x.company
        }))).length
      })
    },
    getUsers () {
      let query = {
        page: 1,
        per_page: 1,
        profil_type: ['seller', 'manager']
      }
      this.$api.userService.get(query).then(r => {
        this.accessSellersCount = r.data.total
      })
    },
    updateCard (v) {
      return v
    },
    openNewMap () {
      if (this.program && this.program.location) {
        const address = `${this.program.location.latitude},${this.program.location.longitude}`
        window.open(`https://maps.google.com/maps?t=h&q=${address}&z=13`, '_blank')
      }
    },
    getCurrentLocation () {
      this.loadingMap = true
      if (localStorage.getItem('userAddress')) {
        this.openGoogleMaps(JSON.parse(localStorage.getItem('userAddress')), this.program.address)
      } else {
        if ('geolocation' in navigator) navigator.geolocation.getCurrentPosition(this.getGoogleMaps)
        else this.loadingMap = false
      }
    },
    getGoogleMaps (position) {
      const geocoder = new window.google.maps.Geocoder()
      const place = {lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude)}
      geocoder.geocode({'location': place}, (results, status) => {
        this.loadingMap = false
        if (status === 'OK') {
          this.openGoogleMaps(results[0].formatted_address, this.program.address)
          localStorage.setItem('userAddress', JSON.stringify(results[0].formatted_address))
        }
      })
      this.loadingMap = false
    },
    openGoogleMaps (results, address) {
      this.loadingMap = false
      const origin = results.split(' ').join('+')
      const destination = `${address.line1 || ''}+${address.zip_code}+${address.city}`
      window.open(`https://www.google.fr/maps/dir/${origin}/${destination}/`, '_blank')
    },
    deleteExternalSale () {
      this.$api.lotService.deleteExternal(this.lot.pk).then(res => {
        this.getLot()
      })
    },
    updateOption (id, data, notify) {
      this.getLot()
      this.loadRunningOptions()
      this.$notify(notify)
    },
    changeOptionEndDate (data) {
      this.$api.optionService.patch(data.option.pk, {end_date: data.date}).then(r => {
        this.loadingOptionAction = false
        this.$notify({
          type: 'is-success',
          text: 'La date de fin de l\'option à été mise à jour.'
        })
        this.updateOption()
      }).catch(() => {
        this.loadingOptionAction = false
        this.$notify({
          type: 'is-danger',
          text: 'Impossible de mettre à jour la date de fin de l\'option.'
        })
      })
    },
    // lockLot (id, locked = false) {
    //   let lotLocked = {locked, status: locked ? 'draft' : 'available'}
    //   this.$api.lotService.patch(id, lotLocked).then(r => {
    //     this.lot = r.data
    //     this.$notify({
    //       type: 'is-success',
    //       text: locked ? 'Le lot a bien été bloqué' : 'Le lot a bien été débloqué'
    //     })
    //   }).catch(() => {
    //     this.$notify({
    //       type: 'is-danger',
    //       text: locked ? 'Erreur lors du bloquage du lot' : 'Erreur lors du débloquage du lot'
    //     })
    //   })
    // },
    loadRunningOptions () {
      let query = {
        per_page: 100,
        status: ['pending', 'waiting_list', 'approved']
      }
      this.$api.optionService.get(query).then(res => {
        this.$store.commit('setRunningOptions', {options: res.data.items})
      })
    },
    sort ({v, e, sortBy}) {
      let params = {
        sort: `${v}:${e.order}`
      }
      this.getLots(this.programPk, params)
      this.sortBy = sortBy
    },
    addToWishlist () {
      this.$api.lotService.postWishlist({lot: this.lot.pk}).then(r => {
        this.$store.commit('addWishlist', {wishlist: r.data})
        this.$notify({
          type: 'is-success',
          text: 'Ajouté aux favoris.'
        })
      }).catch(() => {
        this.$notify({type: 'is-danger', text: 'Erreur lors de l\'ajout aux favoris'})
      })
    },
    deleteFromWishlist () {
      let wishlist = this.wishlists.find(w => w.lot === this.lot.pk)
      this.$api.lotService.deleteWishlist(wishlist.pk).then(r => {
        this.$store.commit('removeWishlist', {wishlistPk: wishlist.pk})
        this.$notify({
          type: 'is-success',
          text: 'Supprimé de la liste des favoris'
        })
      }).catch(() => {
        this.$notify({type: 'is-danger', text: 'Erreur lors de la suppression du favoris'})
      })
    },
    scrollToHash () {
      if (this.$route.hash) {
        // console.log('this.$route. hash :', this.$route.hash)
        setTimeout(() => { this.$scrollTo(this.$route.hash, 100) }, 700)
      } else {
        this.$scrollTo('#app', 700)
      }
    },
    getAllotment () {
      this.$api.accessService.getAllotments({lot: this.lotPk}).then(r => {
        this.allotment = r.data.total
      })
    },
    goToLotsList () {
      this.$scrollTo('#lots')
      if (this.filteredLogement.length === 0 && this.filteredParking.length > 0) {
        this.panelList = 'PARKING'
      }
    }
  },
  created () {
    this.getLot()
  }
}



// WEBPACK FOOTER //
// ./src/components/lot/LotMixins.js